<template>
    <div class="UserInfo">
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label">Район</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" :value="UserInfo.AteName">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label">ФИО координатора</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" placeholder="ФИО" v-model="UserInfo.FioCord">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label">Должность</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" placeholder="Должность" v-model="UserInfo.Subject">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label">Электронная почта</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" placeholder="E-mail" v-model="UserInfo.EMail">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label">Мобильный телефон</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" placeholder="Мобильный телефон" v-model="UserInfo.MobTel">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label">Рабочий телефон</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" placeholder="Рабочий телефон" v-model="UserInfo.WorkTel">
              </div>
            </div>
            <input type='button' class='btn btn-outline-success' value='Сохранить изменения' @click="SendData" />
    </div>
</template>

<script>
import axios from 'axios'

export default{
    data(){
        return{
            UserInfo: {},
            sites: [],
            loaded: false
        }
    },

    created(){
        axios({
          url: 'http://eduqa.egechita.ru/back/userinfo',
          withCredentials: true
          })
        .then(response => {
            //this.sites = response.data,
            //this.loaded = true;
            this.UserInfo = response.data;
        })
    },

    methods:{
        SendData: function(){
            axios({
              url: 'http://eduqa.egechita.ru/back/saveuserinfo',
              withCredentials: true,
              method: 'post',
              data: this.UserInfo
            });
        }
    }
}
</script>
